/**
 * FERP Portal - Role List Page (DRR-074: Tabulator DRY Template)
 *
 * DESIGN Phase: RBAC role definitions for access control.
 * Delegates to TabulatorPrimitiveManager for consistent CRUD across all 25 primitives.
 */

import { TabulatorPrimitiveManager } from '@/components/primitives/TabulatorPrimitiveManager';

export function RoleListPage() {
  return <TabulatorPrimitiveManager primitiveType="role" />;
}

export default RoleListPage;
